import { render, staticRenderFns } from "./DsbFooterColumnContainer.vue?vue&type=template&id=3a9e4800"
import script from "./DsbFooterColumnContainer.vue?vue&type=script&lang=js"
export * from "./DsbFooterColumnContainer.vue?vue&type=script&lang=js"
import style0 from "./DsbFooterColumnContainer.vue?vue&type=style&index=0&id=3a9e4800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports